import { motion } from "framer-motion";
import { BANNER } from "./data";

export const Banner = () => (
  <section
    data-testid="banner-section"
    className="relative bg-[#ffffff] px-3 sm:px-8 pb-10 sm:pb-16"
  >
    <motion.div
      initial={{ opacity: 0, y: 40, scale: 0.98 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="relative max-w-[1400px] mx-auto rounded-2xl sm:rounded-3xl overflow-hidden border border-[#e3e2dc] shadow-[0_30px_80px_-30px_rgba(10,10,11,0.35)]"
    >
      <img
        src={BANNER}
        alt="Deen District Neon Graffiti campaign — the crew in Deen Dunya District sets, varsity jacket and heart hoodie on a rainy neon street, Pre-Order Now"
        className="w-full aspect-[1672/941] object-cover object-center"
      />
    </motion.div>
  </section>
);
